import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .enrique-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      width: 100%;
    }

    h3 {
      font-size: var(--fs-title);
      line-height: var(--lh-title);
      letter-spacing: var(--ls-title);
    }

    h4 {
      font-size: var(--fs-title-small);
      line-height: var(--lh-title);
      letter-spacing: var(--ls-title);
      font-weight: var(--fw-regular);
      margin: 0;
    }

    .block-header {
      grid-row: 2;
      grid-column: 2 / 8;
      /* Design wants 30px to the cards; the grid row gap already gives 15. */
      margin-bottom: calc(15rem / var(--default-rem-px-count));
    }

    /*
      Cards are a fixed fraction of the row — half on mobile, a quarter from
      600px up — so the block reads the same whether the CMS attaches two
      cards or six. Anything past a full row wraps at the same width.
      Column gap is the page gutter above 600px, which puts card edges on the
      page grid lines; mobile carries the 16px the design calls for instead.
    */
    .images {
      grid-row: 3;
      grid-column: 2 / 8;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      row-gap: calc(40rem / var(--default-rem-px-count));
      column-gap: calc(16rem / var(--default-rem-px-count));
    }

    .image-wrapper {
      display: flex;
      flex-direction: column;
      /* Image to description; a description adds 10 more before the CTA. */
      gap: calc(20rem / var(--default-rem-px-count));
    }

    .description + cta-text {
      margin-top: calc(10rem / var(--default-rem-px-count));
    }

    .img-container {
      width: 100%;
      overflow: hidden;
    }

    img {
      display: block;
      width: 100%;
    }

    .description {
      text-wrap: pretty;
      font-size: var(--fs-body);
      line-height: var(--lh-body);
      letter-spacing: var(--ls-body);
    }

    @media (min-width: 600px) {
      .block-header {
        grid-column: 2 / 14;
        /* Row gap is 0 at this breakpoint, so carry the full 60px here. */
        margin-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .images {
        grid-column: 2 / 14;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        column-gap: var(--between-column-padding);
      }
    }
  `,
];
